import { BusinessAssociateTypeBase } from './base/business-associate-type-base';

export class BusinessAssociateType extends BusinessAssociateTypeBase { }